import {createAction} from 'web-app/util/redux/famly-app-helpers';

import type * as Models from './models';

const domain = 'NEW_DEPARTMENT';

export const {
    action: createDepartment,
    success: createDepartmentSuccess,
    failed: createDepartmentFailed,
} = createAction(`${domain}/CREATE_DEPARTMENT`, (institutionId: string, data: Models.FormData) => ({
    institutionId,
    data,
}));
